'use client';
import { useMemo } from 'react';
import { useSwanListboxListContext } from './listbox-list.context.js';

const useSelectedItems = ()=>{
    let { listState: l } = useSwanListboxListContext(), { selectionManager: r, collection: o } = l, { selectedKeys: i } = r, m = useMemo(()=>[
            ...i
        ].map((e)=>o.getItem(e)).filter(Boolean), [
        i,
        o
    ]), s = useMemo(()=>{
        let e;
        let t = o.getFirstKey();
        if (null != t && (e = o.getItem(t)), (null == e ? void 0 : e.type) !== 'item') for (let t of o.getKeys()){
            let l = o.getItem(t);
            if ((null == l ? void 0 : l.type) === 'item') {
                e = l;
                break;
            }
        }
        return e;
    }, [
        o
    ]);
    return useMemo(()=>({
            selectedItems: m,
            selectedItemsOrFirst: m.length > 0 || !s ? m : [
                s
            ]
        }), [
        m,
        s
    ]);
};

export { useSelectedItems };
